import { ErrorHandler } from '@angular/core';
import { environment } from '@qv-env/environment';
import { DefaultErrorHandler, SentryErrorHandler } from 'quantuvis-angular-common/error-handler';

export const errorHandlerFactory = (): ErrorHandler =>
  environment.sentry.enabled
    ? new SentryErrorHandler(environment.sentry, location)
    : new DefaultErrorHandler(location);
